import React, { FunctionComponent, useEffect,useState,useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './GridCustomization.scss';
import { Icon, Button, Loader } from '@scuf/common';
import { getCurrentRole } from 'src/slices/onBoardingSlice';
import { IUpdateGridCustomizationModel } from 'src/models/IGridCustomizationModel';
import {GRID_CUSTOMIZATION_CONSTANTS} from 'src/constants/constants';
import { getGridCustomizationOptions, updateGridCustomizationColumns, setGridCustomizationOptions, getGridCustomizationList } from '../../slices/gridCustomizationSlice';
import { getMessage } from 'src/message/utils';

const GridCustomization: FunctionComponent = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [loader, setLoader] = useState(true);

    const gridCustomizationOptions = useSelector(getGridCustomizationOptions);
    const currentRole = useSelector(getCurrentRole);
    const dispatch = useDispatch();
    const clickOutside = useRef(null);
    const gridCustomizePlaceholder = getMessage('app.anomalies.actions.choosecolumns');
    const selectAllText = getMessage('app.anomalies.actions.choosecolumns.selectAll');
    const applyBtn = getMessage('app.anomalies.actions.choosecolumns.applybtn');
    const resetBtn = getMessage('app.anomalies.actions.choosecolumns.resetbtn');

    const useFilterHideReference = (ref: any) => {
        useEffect(() => {
            function handleClickOutside(event: any) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setIsMenuOpen(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }
    
    useFilterHideReference(clickOutside)

    const loadGridColumnData = async (current_role: string) => {
        getGridCustomizationList(current_role).then((response: any) => {
            dispatch(setGridCustomizationOptions(response));
            setLoader(false);
        });
    };


    const handleMultiselectOnClick = () => {
        if (currentRole && currentRole !== "") {
            loadGridColumnData(currentRole);
            setIsMenuOpen(!isMenuOpen);
        }
    }

    const handleInputCheckboxChange = (event: any) => {

        const userSelectedRecord = gridCustomizationOptions.map((item) => {
            if (item.label_name === event.target.name) {
                return { ...item, default_flag: event.target.checked }
            }
            return item;
        });

        dispatch(setGridCustomizationOptions(userSelectedRecord));
    }


    const handleGridReset = () => {
        const data = {} as IUpdateGridCustomizationModel;
        data["current_role"] = currentRole;
        const res = updateGridCustomizationColumns(data).then((result: any) => {
            dispatch(setGridCustomizationOptions(result));
        });
    }

    const handleGirdApplyOnClick = () => {
        const data = {} as IUpdateGridCustomizationModel;
        data["current_role"] = currentRole;
        data["grid_data"] = gridCustomizationOptions;
        updateGridCustomizationColumns(data);
        setIsMenuOpen(false);
    }



    const handleSelectAllClick = (event: any) => {
        const userSelectedRecords = gridCustomizationOptions.map((item) => {
            if (!item.fixed_flag) {
                return { ...item, default_flag: event.target.checked }
            }
            return item;
        });

        dispatch(setGridCustomizationOptions(userSelectedRecords));

    }

    return (<div className="grid-customization">
        <div className=''>
            <div
                className={`grid-customization__dropdown ${isMenuOpen ? "visible" : ""}`}
                onClick={handleMultiselectOnClick} >
                <div className="text">
                {gridCustomizePlaceholder}
                </div>
                <Icon
                    root="common"
                    size="small"
                    name={isMenuOpen ? "caret-up" : "caret-down"}
                    className="icon"
                ></Icon>
            </div>
            {isMenuOpen && ((<div className={'grid-multiselect'} ref={clickOutside}>
                <div className="multiselect__container">
                    <div className="multiselect__item">
                        <div className="multiselect__item--checkbox">
                            <input type="checkbox" value="All" checked={gridCustomizationOptions.every((item) => (item.default_flag && !item.fixed_flag) || (!item.default_flag && item.fixed_flag))} onChange={handleSelectAllClick}></input>
                            <span className='multiselect__item--checkboxlabel'>{selectAllText}</span>
                        </div>
                    </div>
                    {loader ? (
                        <Loader
                            loading={loader}
                            text="Loading columns..."
                            minHeight="20vh"
                            max-height="50vh"
                            overlayColor="transparent"
                        />
                    ) : gridCustomizationOptions.map((item: any, idx: any) => (
                        <div key={idx}>
                            <div className="multiselect__item">
                                <div className="multiselect__item--checkbox">
                                    <input type="checkbox" name={item.label_name} value={item.label_name} checked={item.fixed_flag || item.default_flag} disabled={item.fixed_flag} onChange={handleInputCheckboxChange}></input>
                                    <span className='multiselect__item--checkboxlabel'>{item.label_name}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="gridcustom__content_button">
                    <Button
                        className="button--secondary"
                        size="small"
                        type="secondary"
                        content={resetBtn}
                        onClick={handleGridReset}
                    />
                    <Button
                        className="button--primary"
                        size="small"
                        type="primary"
                        content={applyBtn}
                        onClick={handleGirdApplyOnClick}
                    />
                </div>
            </div>
            
            ))}
        </div>
    </div>
    );
}


export default GridCustomization;